module.exports = __webpack_public_path__ + "static/media/search.135a1610.svg";